import React from "react";
import ReactMarkdown from "react-markdown";
import { Send, Loader2, Sparkles } from "lucide-react";
import { OFFICER_SUGGESTIONS, OfficerBadge } from "../AIOfficers";

export const ChatView = ({
  officer, officerId, messages, sending, input, setInput, onSend, contextType,
}) => (
  <>
    {/* Messages */}
    <div className="flex-1 overflow-y-auto p-3 space-y-3 custom-scroll" data-testid="floating-dock-messages">
      {messages.length === 0 && (
        <>
          <div className="p-3 rounded-xl bg-purple-500/5 border border-purple-500/15">
            <p className="text-xs text-gray-300 leading-relaxed">
              Hola, soy <span className="text-white font-semibold">{officer?.name}</span>. Estoy detectando contexto: <span className="text-purple-300">{contextType}</span>. Pregunta lo que necesites o usa una sugerencia.
            </p>
          </div>
          {officerId && OFFICER_SUGGESTIONS[officerId] && (
            <div className="space-y-1.5" data-testid="floating-dock-suggestions">
              <p className="text-[10px] uppercase tracking-widest text-purple-400 font-medium px-1 flex items-center gap-1.5">
                <Sparkles className="w-3 h-3" />
                Sugerencias rápidas
              </p>
              {OFFICER_SUGGESTIONS[officerId].map((s, i) => (
                <button
                  key={`sugg-${officerId}-${i}`}
                  onClick={() => onSend(s)}
                  disabled={sending}
                  className="w-full text-left p-2.5 rounded-xl bg-white/[0.02] border border-white/[0.05] hover:bg-purple-500/[0.06] hover:border-purple-500/30 transition-all text-[11px] text-gray-300 leading-snug disabled:opacity-50"
                  data-testid={`floating-dock-suggestion-${i}`}
                >
                  {s}
                </button>
              ))}
            </div>
          )}
        </>
      )}
      {messages.map((m, i) => (
        <div key={m.id || `msg-${i}-${m.role}`} className={m.role === "user" ? "flex justify-end" : "flex items-start gap-2"}>
          {m.role === "user" ? (
            <div className="max-w-[85%] px-3 py-2 rounded-2xl bg-purple-500/15 border border-purple-500/25 text-white text-xs leading-relaxed">{m.content}</div>
          ) : (
            <>
              <OfficerBadge officer={officer} size="sm" />
              <div className={`flex-1 p-2.5 rounded-2xl ${m.error ? "bg-red-500/10 border border-red-500/30" : "bg-white/[0.03] border border-white/[0.05]"}`}>
                <div className="prose prose-invert prose-sm max-w-none text-gray-200 text-xs leading-relaxed">
                  <ReactMarkdown>{m.content}</ReactMarkdown>
                </div>
                {m.latency_ms && (
                  <p className="text-[9px] text-gray-600 mt-1.5 pt-1.5 border-t border-white/5">
                    {(m.latency_ms / 1000).toFixed(1)}s · contexto: {m.context_type}
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      ))}
      {sending && (
        <div className="flex items-start gap-2">
          <OfficerBadge officer={officer} size="sm" />
          <div className="p-2.5 rounded-2xl bg-white/[0.03] border border-white/[0.05]">
            <Loader2 className="w-3.5 h-3.5 animate-spin text-purple-400" />
          </div>
        </div>
      )}
    </div>
    {/* Input */}
    <div className="p-3 border-t border-white/[0.06]">
      <div className="flex gap-2">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
          placeholder={`Pregunta a ${officer?.title}...`}
          rows={2}
          maxLength={1000}
          className="flex-1 px-3 py-2 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-xs placeholder:text-gray-600 focus:outline-none focus:border-purple-500/40 resize-none"
          disabled={sending}
          data-testid="floating-dock-input"
        />
        <button
          onClick={() => onSend()}
          disabled={sending || !input.trim()}
          className="px-3 rounded-xl bg-gradient-to-br from-purple-600 to-pink-600 text-white text-xs font-medium hover:opacity-90 disabled:opacity-30 transition-opacity flex items-center justify-center"
          data-testid="floating-dock-send"
        >
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        </button>
      </div>
    </div>
  </>
);
